/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var g = require("lexical");

exports.registerDragonSupport = function (m) {
  var t = window.location.origin,
      r = function r(l) {
    if (l.origin === t) {
      var h = m.getRootElement();

      if (document.activeElement === h && (h = l.data, "string" === typeof h)) {
        try {
          var a = JSON.parse(h);
        } catch (k) {
          return;
        }

        if (a && "nuanria_messaging" === a.protocol && "request" === a.type && (a = a.payload) && "makeChanges" === a.functionId && (a = a.args)) {
          var _a = a,
              _a2 = _slicedToArray(_a, 5),
              k = _a2[0],
              n = _a2[1],
              p = _a2[2],
              q = _a2[3],
              u = _a2[4];

          m.update(function () {
            var f = g.$getSelection();

            if (g.$isRangeSelection(f)) {
              var e = f.anchor;
              var b = e.getNode(),
                  c = 0,
                  d = 0;
              g.$isTextNode(b) && 0 <= k && 0 <= n && (c = k, d = k + n, f.setTextNodeRange(b, c, b, d));
              if (c !== d || "" !== p) f.insertRawText(p), b = e.getNode();
              g.$isTextNode(b) && (c = q, d = q + u, e = b.getTextContentSize(), c = c > e ? e : c, d = d > e ? e : d, f.setTextNodeRange(b, c, b, d));
              l.stopImmediatePropagation();
            }
          });
        }
      }
    }
  };

  window.addEventListener("message", r, !0);
  return function () {
    window.removeEventListener("message", r, !0);
  };
};